<template>
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>{{ seller_slug }}</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="shop-v2-sub-category.html">Seller Name</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="page-shop u-s-p-t-80">
		<Spinner style="width: 100%; height: 200px" v-if="loading.products" />
		<div class="container products_by_category" v-else>
			<div class="row">
				<!-- Shop-Left-Side-Bar-Wrapper -->
				<Sidebar
					@filterParams="filterProducts"
					:show="sidebar_menu_items"
					:store_info="business_details"
					@search_store="handleSearch"
					@clear_store_search="clearSearch"
				/>
				<div class="col-lg-9 col-md-6 col-sm-12">
					<div class="information-about-wrapper">
						<h1 class="contact-h1">{{ business_details.business_name }}</h1>
						<div v-html="business_details.business_banner"></div>
					</div>
				</div>
				<!-- Shop-Left-Side-Bar-Wrapper /- -->
				<!-- Shop-Right-Wrapper -->
				<div class="col-lg-12 col-md-12 col-sm-12" id="seller_products">
					<!-- Page-Bar -->
					<SortBar @sortBy="SortProducts" />
					<!-- Page-Bar /- -->
					<!-- Row-of-Product-Container -->
					<div class="row product-container grid-style">
						<!-- Product Not Found -->
						<div
							class="product-not-found"
							v-if="products.length == 0 && !loading.products && !loading.search"
							style="width: 100%"
						>
							<div class="not-found">
								<h2>SORRY!</h2>
								<!-- 28.9844646 -->
								<h6>There is not any products.</h6>
							</div>
						</div>
						<!-- Product Not Found /- -->
						<ProductLoader
							className="col-lg-3 col-md-4 col-sm-6"
							v-if="loading.search"
							v-for="i in 9"
							:key="i"
						/>
						<Product
							className="col-lg-3 col-md-4 col-sm-6"
							:product="product"
							v-for="product in products"
							:key="product.id"
							:sortBy="sortBy"
						/>
						<Spinner style="width: 100%; height: 200px" v-if="loading.page" />
						<div
							v-if="
								currentPage != lastPage && !loading.products && !loading.page && !loading.search
							"
							class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
							style="width: 100%"
						>
							<a class="redirect-link" href="#" @click.prevent="viewMore">View more</a>
						</div>
						<div
							v-if="
								currentPage == lastPage && !loading.products && !loading.page && !loading.search
							"
							class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
							style="width: 100%"
						>
							<a class="redirect-link">No More Products..</a>
						</div>
					</div>
					<!-- Row-of-Product-Container /- -->
				</div>
				<!-- Shop-Right-Wrapper /- -->
			</div>
		</div>
	</div>
	<vue-element-loading
		:active="status.cart.loading && !getStatus.products.loading"
		spinner="spinner"
		is-full-screen
		color="#343a40"
		text="Adding Product"
	/>
	<Footer />
</template>
<script>
	import PageIntroduction from "../components/Shop/PageIntroduction.vue";
	import Footer from "../components/Bottom/Footer.vue";
	import ShopIntro from "../components/Shop/ShopIntro.vue";
	import {publicPath} from "../../vue.config";
	import Spinner from "../components/Loaders/Spinner.vue";
	import Sidebar from "../components/Sections/Products/Sidebar/Sidebar.vue";
	import {mapActions, mapGetters} from "vuex";
	import SortBar from "../components/Sections/Products/SortBar/SortBart.vue";
	import {ContentLoader} from "vue-content-loader";
	import Product from "../components/Sections/Product.vue";
	import ProductLoader from "../components/Loaders/ProductLoader.vue";
	import axios from "axios";
	export default {
		props: ["cat_name"],
		components: {
			PageIntroduction,
			Footer,
			ShopIntro,
			Spinner,
			Sidebar,
			SortBar,
			ContentLoader,
			Product,
			ProductLoader,
		},
		data() {
			return {
				publicPath: publicPath,
				products: [],
				loading: {
					products: false,
					page: false,
					search: false,
				},
				currentPage: 1,
				lastPage: 0,
				sortBy: "featured",
				seller_slug: this.$route.params.slug,
				business_details: {},
				sidebar_menu_items: ["search_store"],
				searchString: "",
				category_id: this.$route.query.category_id,
			};
		},
		computed: {
			...mapGetters("products", [
				"getProducts",
				"getStatus",
				"getBrands",
				"getLastPage",
			]),
			...mapGetters("cat", ["getCategories"]),
			...mapGetters("cart", ["getCarts", "status"]),
			...mapGetters("wishlist", ["getWishListItems"]),
		},
		methods: {
			scroll() {
				const el = document.getElementById("seller_products");
				this.$smoothScroll({
					scrollTo: el, // scrollTo is also allowed to be number
					// offset: -100,
				});
			},
			async fetchSellerDetails(loading_type) {
				this.loading[loading_type] = true;
				let url = `${process.env.VUE_APP_API_URL}/api/warehouses/get-range?seller_slug=${this.seller_slug}`;
				if (this.category_id) {
					url += `&category_id=${this.category_id}`;
				}
				if (this.searchString) {
					url += `&searchBy=${this.searchString}`;
				}
				url += `&sortBy=${this.sortBy}&page=${this.currentPage}`;
				try {
					const {data} = await axios.post(url, null);
					if (this.sortBy === "featured") {
						data.payload.data.unshift(...data.payload.featured); // append featured products to the top of the list
					}
					this.products.push(...data.payload.data);
					this.lastPage = data.payload.last_page;
					this.business_details = data.payload.businessDetail || this.business_details;
					this.loading[loading_type] = false;
				} catch (error) {
					console.log(error);
					this.loading[loading_type] = false;
				}
			},
			SortProducts(sortBy) {
				this.products = []; // reset products
				this.currentPage = 1;
				this.sortBy = sortBy;
				this.fetchSellerDetails("search");
			},
			viewMore() {
				this.currentPage++;
				this.fetchSellerDetails("page");
			},
			filterProducts(params) {
				console.log(params);
			},
			handleSearch(searchString) {
				this.scroll();
				this.searchString = searchString;
				this.products = []; // reset products
				this.currentPage = 1;
				this.fetchSellerDetails("search");
			},
			clearSearch() {
				this.products = []; // reset products
				this.searchString = "";
				this.currentPage = 1;
				this.fetchSellerDetails("search");
			},
		},
		mounted() {
			this.fetchSellerDetails("products");
		},
		beforeUnmount() {},
		watch: {
			$route(to, from) {
				//when id changes then we need to reset filter.
				if (to.query.category_id) {
					this.scroll();
					this.products = [];
					this.category_id = to.query.category_id;
					this.fetchSellerDetails("products");
				}
			},
		},
	};
</script>
<style>
	.active {
		font-weight: bold;
	}
	.products_div {
		width: 100%;
		display: flex;
		flex-flow: inherit;
	}
</style>
